import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { formatDate, formatDateTime } from 'Shared/helpers'
import {
  GlgTooltipIcon,
} from 'SharedComponents'
import RegStatusComponent from './reg_status_component'
import LinksComponent from './links_component'
import moment from 'moment'
import _ from 'lodash'
import { handleRowClick } from 'Shared/helpers'

const EventRegularItemComponent = ({
  id, name, courses, startDate, endDate, tourName, registrationInfo, showInvStartsAtColumn, showOpeningDatesColumn, showEndsAtColumn, showStartsAtColumn,
  logo, showRegistrationColumns, GGIDGuestLoginURL, registered, hasCartship, websiteMultiRegistrationCartURL, condition1, condition2, condition3, condition4, conditionForCart, leagueMultiEventsRegistration,
  MRMember, registerPath, bookNowPath, hasOpenTeeTimes, hasBookingAfterRegister, product, registrationTypes, cartCartshipPath, cartCondition, cartConditionWithInclude, widgetsMPPath, teeSheetPath, resultsPath, addToCart, addToCartPath, willBeWaitlisted, willBePending, willBeDisabled,
  idsForLabels, registrationWithPayments, cartMerchantAccountId, cartMerchantAccountType, statusFilter, showCourseInfo, directoryHideGolfers, shouldHideRegistration, exemptionEventLink, waitlist, showLotteryColumns, showLotteryStartsAtColumn, showLotteryEndsAtColumn, hasEnteredLottery,
  customerTimeFormat,
}) => {

  const showPayments = (registrationTypes.length !== 0 && registrationTypes)

  const condRegistrationDates = (showInvStartsAtColumn && registrationInfo.inv_starts_at) ||
                                (showOpeningDatesColumn && !_.isEmpty(registrationInfo.memberships_info)) ||
                                (showStartsAtColumn && registrationInfo.starts_at) ||
                                (showEndsAtColumn && registrationInfo.ends_at)
  const condRegistrationTypes = (showPayments && registrationTypes)

  const condLotteryDates = (showLotteryStartsAtColumn && registrationInfo.lottery_starts_at) ||
                           (showLotteryEndsAtColumn && registrationInfo.lottery_ends_at)

  const cond = condRegistrationDates || condRegistrationTypes || condLotteryDates

  const linksProps = {
    startDate: startDate,
    hasCartship: hasCartship,
    websiteMultiRegistrationCartURL: websiteMultiRegistrationCartURL,
    condition1: condition1,
    condition2: condition2,
    condition3: condition3,
    condition4: condition4,
    conditionForCart: conditionForCart,
    leagueMultiEventsRegistration: leagueMultiEventsRegistration,
    GGIDGuestLoginURL: GGIDGuestLoginURL,
    MRMember: MRMember,
    registerPath: registerPath,
    bookNowPath: bookNowPath,
    hasOpenTeeTimes: hasOpenTeeTimes,
    hasBookingAfterRegister: hasBookingAfterRegister,
    product: product,
    registrationTypes: registrationTypes,
    id: id,
    cartCartshipPath: cartCartshipPath,
    cartCondition: cartCondition,
    cartConditionWithInclude: cartConditionWithInclude,
    eligibilityMessage: registrationInfo.eligibility_message,
    widgetsMPPath: widgetsMPPath,
    status: registrationInfo.status,
    teeSheetPath: teeSheetPath,
    resultsPath: resultsPath,
    onClick: addToCart,
    addToCartPath: addToCartPath,
    willBeWaitlisted: willBeWaitlisted,
    willBePending: willBePending,
    willBeDisabled: willBeDisabled,
    registrationWithPayments: registrationWithPayments,
    merchantAccountId: registrationInfo.merchant_account_id,
    merchantAccountTypeAccount: registrationInfo.merchant_account_type_account,
    cartMerchantAccountId: cartMerchantAccountId,
    cartMerchantAccountType: cartMerchantAccountType,
    exemptionEventLink: exemptionEventLink,
    shouldHideRegistration: shouldHideRegistration,
  }
  let rowSpan
  cond ? rowSpan = 2 : rowSpan = 1

  const onRowClick = (event) => {
    handleRowClick(event, shouldHideRegistration, linksProps.resultsPath)
  }

  let displayMyRegistrations = true
  if (statusFilter) {
    statusFilter.includes('my_registrations') ? displayMyRegistrations = true : displayMyRegistrations = false
  }

  let hideRegistration = ''
  if (shouldHideRegistration) {
    hideRegistration += ' hidden'
  }

  return (
    <div>
      <div>
        { idsForLabels[id] && MRMember && displayMyRegistrations && (
          <div className='page_title add-padding-top-10 font-size-14 labels-margin-xs'>
            <div className='text'>
              {idsForLabels[id] === 'registered' ? !window.I18n ? '' : window.I18n.t('customer_directories.condensed_view.my_registrations') : !window.I18n ? '' : window.I18n.t('customer_directories.condensed_view.all_events')}
            </div>
          </div>
        )}
      </div>
      <table className='table table-hover table-striped table-condensed table-bordered customer_directory_table'>
        <tbody className='render_directories_table'>
          <tr className='white-row tr-content'>
            {registrationInfo.status === '' && (
              <td className={'empty-reg-status reg-status' + hideRegistration} rowSpan={rowSpan}></td>
            )}
            {(showRegistrationColumns || showLotteryColumns) && registrationInfo.status && (
              <RegStatusComponent
                registered={registered}
                waitlist={waitlist}
                status={registrationInfo.status}
                endsAt={registrationInfo.ends_at}
                startsAt={registrationInfo.starts_at}
                invStartsAt={registrationInfo.can_inv_list ? registrationInfo.inv_starts_at : ''}
                openingDates={registrationInfo.can_membership_programs ? registrationInfo.memberships_info.map(m => m.start_date) : []}
                timezone={registrationInfo.time_zone}
                membershipsAbbreviation={registrationInfo.memberships_info.map(m => m.abbreviation)}
                rowSpan={rowSpan}
                lotteryStartsAt={registrationInfo.lottery_starts_at}
                lotteryEndsAt={registrationInfo.lottery_ends_at}
                hasEnteredLottery={hasEnteredLottery}
                shouldHideRegistration={shouldHideRegistration}
                customerTimeFormat={customerTimeFormat} />
            )}

            <td className={`${shouldHideRegistration ? 'clickable' : ''}`} colSpan='2' onClick={onRowClick}>
              <Row>
                <Col xs={9}>
                  {logo && (
                    <Col xs={3}>
                      <div className='logo'>
                        <a href={!shouldHideRegistration ? GGIDGuestLoginURL : ''} className={`${shouldHideRegistration ? 'no_hover' : ''}`} target={'_top'}>
                          <img src={logo} className="img-responsive" style={{maxHeight: '85px'}} />
                        </a>
                      </div>
                    </Col>
                  )}
                  <Col xs={logo ? 9 : 12}>
                    <div className='information'>
                      <a href={!shouldHideRegistration ? GGIDGuestLoginURL : ''} className={`league-name ${shouldHideRegistration ? 'no_hover' : ''}`} target={'_top'}>
                        <b>
                          { name } 
                        </b>
                      </a>
                      <br />
                      {startDate === endDate ? formatDate(startDate, '', 'ddd, MMM D, YYYY') : formatDate(startDate, '', 'ddd, MMM D, YYYY') + ' - ' + formatDate(endDate, '', 'ddd, MMM D, YYYY')}
                      <br />
                      {showCourseInfo && (
                        <span>
                          { `${!window.I18n ? '' : window.I18n.t('customer_directories.event.course')}: ` }
                          {(courses.length > 0 && courses.length <= 2) ? (
                            courses.join(', ')
                            ) : (
                              <Fragment>
                                { !window.I18n ? '' : window.I18n.t('customer_directories.event.multiple_courses') }
                                <GlgTooltipIcon tooltip={courses.join('\n')} tooltipClass="custom-tooltip" />
                              </Fragment>
                            )
                          }
                        </span>
                      )}
                      {tourName && (
                        <div>
                          <span>
                            {`${!window.I18n ? '' : window.I18n.t('customer_directories.event.tour')}: ` + tourName}
                          </span>
                          {!directoryHideGolfers && (
                            <Fragment>
                              <div className='circle_divider'></div>
                              <span>
                                {`${!window.I18n ? '' : window.I18n.t(
                                  'customer_directories.event.golfers',
                                  { participant_plural_capitalize: product === 'non-golf-event' ? 'Participants' : 'Golfers' }
                                )}: ` + registrationInfo.registered_members}
                              </span>
                            </Fragment>
                          )}
                        </div>
                      )}
                      {!tourName && !directoryHideGolfers && (
                        <div>
                          <span>
                            {`${!window.I18n ? '' : window.I18n.t(
                              'customer_directories.event.golfers',
                              { participant_plural_capitalize: product === 'non-golf-event' ? 'Participants' : 'Golfers' }
                            )}: ` + registrationInfo.registered_members}
                          </span>
                        </div>
                      )}
                      {exemptionEventLink && (
                        <div>
                          <span className={`${hideRegistration}`}>
                            { !window.I18n ? '' : window.I18n.t('customer_directories.event.exempt') }
                            <a href={exemptionEventLink} target={'_top'}>
                              { !window.I18n ? '' : window.I18n.t('customer_directories.event.here') }
                            </a>
                          </span>
                        </div>
                      )}
                    </div>
                  </Col>
                </Col>
                <Col xs={12} lg={3} md={3} sm={3} className={`${hideRegistration} add-margin-top-10`}>
                  <div className='links registration_links_container text-right'>
                    <LinksComponent linksProps={linksProps} status={registrationInfo.status} />
                  </div>
                </Col>
              </Row>
            </td>
          </tr>
          { registrationInfo.status && cond && (
            <tr className='gray-row tr-content'>
              { (condRegistrationDates || condLotteryDates) && (
                <td colSpan={condRegistrationTypes ? 1 : 2} height={1}>
                  <div className='col-xs-11'>
                    {showLotteryStartsAtColumn && registrationInfo.lottery_starts_at && (
                      <div className='pl-15 mb-5'>
                        <span className='semi-bold'>
                          { !window.I18n ? '' : window.I18n.t('customer_directories.registration.lottery_opens') + ':'}
                        </span>
                        {' ' + formatDateTime(registrationInfo.lottery_starts_at, registrationInfo.time_zone, `ddd, MMM DD, YYYY ${customerTimeFormat}`)}
                      </div>
                    )}
                    {showLotteryEndsAtColumn && registrationInfo.lottery_ends_at && (
                      <div className='pl-15 mb-5'>
                        <span className='semi-bold'>
                          {!window.I18n ? '' : window.I18n.t('customer_directories.registration.lottery_closes') + ':'}
                        </span>
                        {' ' + formatDateTime(registrationInfo.lottery_ends_at, registrationInfo.time_zone, `ddd, MMM DD, YYYY ${customerTimeFormat}`)}
                      </div>
                    )}
                    {showInvStartsAtColumn && registrationInfo.inv_starts_at && registrationInfo.can_inv_list === true && (
                      <div className='pl-15 mb-5'>
                        <span className='semi-bold'>
                          {`${!window.I18n ? '' : window.I18n.t('customer_directories.registration.opens_for_invitation_list')}:`}
                        </span>
                        {' ' + formatDateTime(registrationInfo.inv_starts_at, registrationInfo.time_zone, `ddd, MMM DD, YYYY ${customerTimeFormat}`)}
                    </div>
                    )}
                    {showOpeningDatesColumn &&
                      !_.isEmpty(registrationInfo.memberships_info) &&
                      registrationInfo.can_membership_programs &&
                      registrationInfo.memberships_info
                        .sort((a, b) => {
                          return moment(a.start_date) - moment(b.start_date)
                        }).map( membershipProgram => {
                      return (
                        <div className='pl-15 mb-5' key={membershipProgram.id}>
                          <span className='semi-bold'>
                            {!window.I18n ? '' : window.I18n.t('customer_directories.registration.opens_for_membership_program', {membershipProgram: membershipProgram.abbreviation})}
                            <GlgTooltipIcon tooltip={membershipProgram.name}>
                              <i className='gga-info-circle' />
                            </GlgTooltipIcon>
                            :
                          </span>
                          {` ${ formatDateTime(membershipProgram.start_date, registrationInfo.time_zone, `ddd, MMM DD, YYYY ${customerTimeFormat}`) }`}
                        </div>
                      )
                    })}
                    {showStartsAtColumn && registrationInfo.starts_at && (
                      <div className='pl-15 mb-5'>
                        <span className='semi-bold'>
                          {(registrationInfo.can_inv_list === true && registrationInfo.inv_starts_at ) ? `${!window.I18n ? '' : window.I18n.t('customer_directories.registration.opens_for_everyone')}:  ` : `${!window.I18n ? '' : window.I18n.t('customer_directories.registration.opens')}: `}
                        </span>
                        {formatDateTime(registrationInfo.starts_at, registrationInfo.time_zone, `ddd, MMM DD, YYYY ${customerTimeFormat}`)}
                      </div>
                    )}
                    {showEndsAtColumn && registrationInfo.ends_at && (
                      <div className='pl-15 mb-5'>
                        <span className='semi-bold'>
                          {!window.I18n ? '' : window.I18n.t('customer_directories.registration.closes') + ':'}
                        </span>
                        {' ' + formatDateTime(registrationInfo.ends_at, registrationInfo.time_zone, `ddd, MMM DD, YYYY ${customerTimeFormat}`)}
                      </div>
                    )}
                  </div>
                  <div className='col-xs-1 time-zone-info'>
                    <GlgTooltipIcon tooltip={!window.I18n ? '' : window.I18n.t('customer_directories.tooltips.date_time_displayed_in', {time_zone: registrationInfo.time_zone_display})}>
                      <i className='gga-info-circle' />
                    </GlgTooltipIcon>
                  </div>
                </td>
              )}

              { condRegistrationTypes && (
                <td colSpan={condRegistrationDates ? 1 : 2} style={{width: 400}}>
                  {registrationTypes.length !== 0 && (
                    <ul className="registration-types-ul">
                      {registrationTypes.map((registration, i) => {     
                          // Return the element. Also pass key  
                          return (
                            <li className='pl-15 mb-5' key={i}>
                              <span className='semi-bold registration_label'>
                                {registration.name}
                              </span>

                              {registration.priceText}
                              {registration.withoutMembershipProgramText.length > 0 && (
                                <div className='pull-right'>
                                  <GlgTooltipIcon tooltip={registration.withoutMembershipProgramText}>
                                    <i className='gga-info-circle' />
                                  </GlgTooltipIcon>
                                </div>
                              )}
                            </li>
                          ) 
                        })
                      }
                    </ul>
                  )}
                </td>
              )}
            </tr>
          )}
        </tbody>
        <tr className='tr-content height-20 empty-row'></tr>
      </table>
    </div>
  )
}

EventRegularItemComponent.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  tourName: PropTypes.string,
  courses: PropTypes.array,
  registrationInfo: PropTypes.object,
  showInvStartsAtColumn: PropTypes.bool,
  showOpeningDatesColumn: PropTypes.bool,
  registrationTypes: PropTypes.array,
  showEndsAtColumn: PropTypes.bool,
  showStartsAtColumn: PropTypes.bool,
  logo: PropTypes.string,
  showRegistrationColumns: PropTypes.bool,
  GGIDGuestLoginURL: PropTypes.string,
  registered: PropTypes.bool,
  hasCartship: PropTypes.bool,
  websiteMultiRegistrationCartURL: PropTypes.string,
  condition1: PropTypes.bool,
  condition2: PropTypes.bool,
  condition3: PropTypes.bool,
  condition4: PropTypes.bool,
  conditionForCart: PropTypes.bool,
  leagueMultiEventsRegistration: PropTypes.bool,
  MRMember: PropTypes.object,
  registerPath: PropTypes.string,
  bookNowPath: PropTypes.string,
  hasOpenTeeTimes: PropTypes.bool,
  hasBookingAfterRegister: PropTypes.bool,
  product: PropTypes.string,
  cartCartshipPath: PropTypes.string,
  cartCondition: PropTypes.bool,
  cartConditionWithInclude: PropTypes.bool,
  widgetsMPPath: PropTypes.string,
  resultsPath: PropTypes.string,
  teeSheetPath: PropTypes.string,
  addToCart: PropTypes.func,
  idsForLabels: PropTypes.object,
  addToCartPath: PropTypes.string,
  willBeWaitlisted: PropTypes.bool,
  willBePending: PropTypes.bool,
  willBeDisabled: PropTypes.bool,
  registrationWithPayments: PropTypes.bool,
  cartMerchantAccountId: PropTypes.string,
  cartMerchantAccountType: PropTypes.string,
  statusFilter: PropTypes.array,
  showCourseInfo: PropTypes.bool,
  directoryHideGolfers: PropTypes.bool,
  exemptionEventLink: PropTypes.string,
  waitlist: PropTypes.string,
  showLotteryColumns: PropTypes.bool,
  showLotteryStartsAtColumn: PropTypes.bool,
  showLotteryEndsAtColumn: PropTypes.bool,
  hasEnteredLottery: PropTypes.bool,
  shouldHideRegistration: PropTypes.bool,
  customerTimeFormat: PropTypes.string,
}

EventRegularItemComponent.defaultProps = {
}

export default EventRegularItemComponent
